import "./HeadingConfigGrupos.css";
import { ButtonGeneric } from "../ButtonGeneric/buttonGeneric";
import FormBasicInfoSelect from "../formBasicInfo/formBasicInfoSelect";
import PlusButtonFilter from "../../assets/svgs/plusButtonFilter.svg";
import { GroupItem } from "../../types/gruposResponsabilidade";

export interface HeadingConfigGruposGroupOption {
  id: string;
  name: string;
}

export interface HeadingConfigGruposAction {
  label: string;
  onClick: () => void;
  disabled?: boolean;
  variant?: "default" | "danger";
}

export interface HeadingConfigGruposTab {
  id: string;
  label: string;
  hidden?: boolean;
  disabled?: boolean;
}

export interface HeadingConfigGruposProps {
  title: string;
  description?: string;
  buttonTitle?: string;
  onNewGroup?: () => void;
  groupOptions?: HeadingConfigGruposGroupOption[];
  selectedGroupId?: string;
  selectedGroup?: GroupItem | null;
  onGroupChange?: (groupId: string) => void;
  action?: HeadingConfigGruposAction;
  tabs?: HeadingConfigGruposTab[];
  activeTab?: string;
  onTabChange?: (tabId: string) => void;
}

const HeadingConfigGrupos = ({
  title,
  description,
  buttonTitle,
  onNewGroup,
  groupOptions,
  selectedGroupId,
  selectedGroup,
  onGroupChange,
  action,
  tabs,
  activeTab,
  onTabChange,
}: HeadingConfigGruposProps) => {
  const hasGroupSelector =
    !!groupOptions && selectedGroupId !== undefined && !!onGroupChange;
  const legacyAction: HeadingConfigGruposAction | undefined =
    buttonTitle && onNewGroup
      ? {
          label: buttonTitle,
          onClick: onNewGroup,
        }
      : undefined;
  const configuredAction = action ?? legacyAction;
  const visibleTabs = tabs?.filter((tab) => !tab.hidden) ?? [];
  const administrator =
    selectedGroup?.engineerResponsible.email ??
    selectedGroup?.engineerResponsible.name;

  return (
    <section className="groupsHeading">
      <div className="groupsHeadingContent">
        <div>
          <h1 className="groupsHeadingTitle">{title}</h1>
        </div>
        {hasGroupSelector ? (
          <div className="groupsHeadingGroupSelector">
            <FormBasicInfoSelect
              label="Use o seletor para alternar o grupo"
              ariaLabel="Grupo para configurar"
              value={selectedGroupId ?? ""}
              onChange={(event) => onGroupChange?.(event.target.value)}
              options={(groupOptions ?? []).map((option) => ({
                value: option.id,
                label: option.name,
              }))}
            />
          </div>
        ) : (
          configuredAction && (
            <div className="groupsHeadingAction">
              <ButtonGeneric
                img={PlusButtonFilter}
                title={configuredAction.label}
                colorTitle="#FFFFFF"
                style="buttonHeading"
                disabled={configuredAction.disabled}
                onClick={configuredAction.onClick}
              />
            </div>
          )
        )}
      </div>

      {selectedGroup ? (
        <div className="groupsHeadingGroupDetails">
          <div className="groupsHeadingGroupInfo">
            <h2 className="groupsHeadingGroupName">{selectedGroup.name}</h2>
            <div className="groupsHeadingGroupMeta">
              <span>
                Administrador de Engenharia: <strong>{administrator}</strong>
              </span>
              <span>
                Participantes: <strong>{selectedGroup.participantsCount}</strong>
              </span>
            </div>
          </div>

          {action && (
            <button
              type="button"
              className={`groupsHeadingContextAction groupsHeadingContextAction-${
                action.variant ?? "default"
              }`}
              disabled={action.disabled}
              onClick={action.onClick}
            >
              {action.label}
            </button>
          )}
        </div>
      ) : (
        description && (
          <div>
            <p className="groupsHeadingDescription">{description}</p>
          </div>
        )
      )}

      {visibleTabs.length > 0 && activeTab && onTabChange && (
        <div className="groupsHeadingTabs" role="tablist" aria-label="Abas do grupo">
          {visibleTabs.map((tab) => (
            <button
              key={tab.id}
              type="button"
              role="tab"
              aria-selected={activeTab === tab.id}
              className={
                activeTab === tab.id
                  ? "groupsHeadingTab groupsHeadingTabActive"
                  : "groupsHeadingTab"
              }
              disabled={tab.disabled}
              onClick={() => onTabChange(tab.id)}
            >
              {tab.label}
            </button>
          ))}
        </div>
      )}
    </section>
  );
};

export default HeadingConfigGrupos;